import React from "react";
import EcommerceHeader from "../Header/Header";
import Footer from "../Footer/Footer";
import { ProductDetailSkeleton } from "./ProductSkeletons";

interface ProductDetailLayoutProps {
  loading: boolean;
  error: string | null;
  onBackToProducts: () => void;
  children: React.ReactNode;
}

const ProductDetailLayout: React.FC<ProductDetailLayoutProps> = ({
  loading,
  error,
  onBackToProducts,
  children,
}) => {
  if (loading) {
    return (
      <div className="min-h-screen bg-white">
        <EcommerceHeader />
        <ProductDetailSkeleton />
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-white">
        <EcommerceHeader />
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="text-center py-12">
            <div className="text-red-500 text-lg mb-4">{error}</div>
            <button
              onClick={onBackToProducts}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:opacity-90 transition-colors font-medium"
            >
              Back to Products
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <EcommerceHeader />
      <div className="max-w-7xl mx-auto px-4 py-8">{children}</div>
      <Footer />
    </div>
  );
};

export default ProductDetailLayout;
